import { Heading, Input, Switch } from '@orobix/orobix-fe-components'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { msalInstance } from '../../../auth/config'
import useStyles from '../styles'
import { Settings } from '../types'

const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i

type E = React.ChangeEvent<HTMLInputElement>

interface NotificationsSettingsProps {
  settings?: Settings
  updateSettings?: (settings: Partial<Settings>) => void
  isLoading: boolean
  isInSettingsPage?: boolean
}

const NotificationsSettings = ({
  settings,
  updateSettings,
  isLoading,
  isInSettingsPage = true,
}: NotificationsSettingsProps) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const [error, setError] = useState<boolean>(false)

  const account = msalInstance.getActiveAccount()
  const [emailEnabled, setEmailEnabled] = useState<boolean>(false)
  const [email, setEmail] = useState<string>('')

  const isValidEmail = (value: string) =>
    EMAIL_REGEX.test(value) || value === ''

  useEffect(() => {
    if (settings) {
      setEmailEnabled(settings?.notification__email_enabled)
      setEmail(settings.notification__email)
    }
  }, [settings])

  useEffect(() => {
    setError(!isValidEmail(email))
  }, [email])

  return (
    <>
      {isInSettingsPage && (
        <Heading headingLevel="1" headingLevelStyle="3">
          {t('Notifications')}
        </Heading>
      )}
      <div
        className={isInSettingsPage ? classes.select : undefined}
        id="divTrainingNotificationsId"
      >
        <Switch
          id="email-enabled"
          text={
            isInSettingsPage
              ? t('Enable email notifications')
              : t('Send email notification when the execution is completed')
          }
          isToggled={emailEnabled}
          disabled={isLoading}
          onToggle={() => {
            setEmailEnabled(!emailEnabled)
            if (updateSettings) {
              updateSettings({
                notification__email_enabled: !emailEnabled,
              })
            }
          }}
        />
        {isInSettingsPage && (
          <Input
            name="Email"
            id="email"
            type="email"
            value={email}
            placeholder={account?.username || ''}
            onChange={(e: E) => setEmail(e.target.value)}
            onBlur={(e: E) => {
              if (updateSettings && isValidEmail(e.target.value)) {
                updateSettings({
                  notification__email: e.target.value,
                })
              }
            }}
            disabled={isLoading || !emailEnabled}
            error={emailEnabled && error}
          />
        )}
      </div>
    </>
  )
}

export default NotificationsSettings
